export default "__VITE_ASSET__bbac9c47__"